<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle"><span class="l-pageLabel">お問い合わせ</span>受付No. {{ inputForm.inquiryId }}</h1>
      <div class="l-btn-title-right-pos">
        <div class="btn-basic-small" @click="goInquiryList()"><a>一覧へ戻る</a></div>
      </div>
      <div class="l-contentsBox">
        <table class="l-form-table">
          <caption>お問い合わせ内容</caption>
          <tr>
            <th class="v-middle"><span>お問い合わせ元</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ inputForm.reqCorporation.corpNm }}&nbsp;{{ inputForm.reqUser.nm }}様</span><br >
              <span style="padding-left: 20px;">電話番号：(代表){{ inputForm.reqCorporation.telNo }}&nbsp;(直通){{ inputForm.reqUser.telNo }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>お問い合わせ日時</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ $dayjs(inputForm.reqTs).format("YYYY/MM/DD HH:mm:ss") }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>ご用件</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ inputForm.inquiryKbnLabel }}</span>
            </td>
          </tr>
          <tr>
            <th><span>お問い合わせ内容</span></th>
            <td>
              <p style="padding-left: 20px; white-space: pre-line;">{{ inputForm.inquiry }}</p>
            </td>
          </tr>
          <tr v-if="inputForm.reqFile">
            <th class="v-middle"><span>添付ファイル</span></th>
            <td class="v-middle">
              <a @click="downloadInquiryFile(inputForm.reqFile.fileId, 'inq_req')" class="file_download" style="padding-left: 20px;">
                {{ inputForm.reqFile.fileNm }}
              </a>
            </td>
          </tr>
        </table>
        <table class="l-form-table">
          <caption>お問い合わせ回答</caption>
          <tr>
            <th class="v-middle"><span>ご回答</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextArea v-model="$v.inputForm.$model.res" @input="$v.inputForm.$touch()" class="l-formGroup__textArea" />
              </div>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>添付ファイル</span></th>
            <td class="v-middle">
              <input type="file" v-on:change="fileSelected" style="padding-left: 20px;">
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>メモ欄</span></th>
            <td class="v-middle">
              <div class="l-inputAccount" style="width:100%;">
                <TextArea v-model="$v.inputForm.$model.remarks" @input="$v.inputForm.$touch()" class="l-formGroup__textArea" />
              </div>
            </td>
          </tr>
        </table>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()"><a>登録</a></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import constant from '@/const';
import { saveAs } from "file-saver";

export default {
  components: {
    Loading,
    TextArea
  },
  data() {
    return {
      isProcessing: false,
      inputForm: {
        inquiryId: '',
        inquiryKbn: 1,
        inquiry: '',
        inquiryKbnLabel: '',
        res: '',
        remarks: '',
        reqTs: null,
        reqCorporation: {
          corpNm: '',
          telNo: ''
        },
        reqUser: {
          nm: '',
          telNo: ''
        },
        reqFile: {
          fileNm: '',
        },
      },
      file: {
        fileNm: ''
      },
      fileInfo: '',
      selectInquiryKbnList: constant.INQUIRY_KBN,
    }
  },
  validations: {
    inputForm: {
      inquiryKbn: { },
      inquiry: { },
      res: { },
      remarks: { },
    },
  },
  computed: {
    inquiryId() {
      return this.$store.getters['portal/getInquiryId'];
    }
  },
  created: function() {
    this.getInquiry(this.inquiryId);
  },
  methods: {
    async getInquiry(inquiryId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/inquiry/getInquiry', {
        inquiryId: inquiryId,
      });
      if (res) {
        this.inputForm = res.data.inquiry;
        const tmpInquiryKbn = this.inputForm.inquiryKbn;
        let inquiryKbn = constant.INQUIRY_KBN.find(function(element){
          return element.value === tmpInquiryKbn;
        }, tmpInquiryKbn);
        this.inputForm.inquiryKbnLabel = inquiryKbn.label;
      }
      this.isProcessing = false;
    },
    fileSelected(event) {
      this.fileInfo = event.target.files[0];
    },
    async register() {
      this.isProcessing = true;
      const formData = new FormData()
      formData.append('inquiryId', this.inquiryId)
      formData.append('file', this.fileInfo)
      formData.append('inquiry', JSON.stringify(this.inputForm))
      let res = await this.$axios.post('/ld/api/inquiry/store', formData);
      if (res.status === 200) {
        this.$store.dispatch('alert/setMessage', '登録が完了しました');
        this.$router.push({ name: 'inquiry-list' });
      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },
    goInquiryList() {
      const params = {};
      this.$router.push({ name: 'inquiry-list', params: params });
    },
    async downloadInquiryFile(fileId, fileType) {
      await saveAs('/ld/api/inquiry/downloadInquiryFile?inquiryId=' + this.inquiryId + '&fileId=' + fileId + '&fileType=' + fileType);
    },
  }
}
</script>

<style scoped>
.file_download {
  color: #0070be;
  text-decoration: underline;
  display: inline-block;
  line-height: 1.6;
}
</style>